export const _connectionString = 'https://search.instar.wiki';
// export const _connectionString = 'http://localhost:9200';
// export const _connectionString = 'http://192.168.2.110:9200';
// export const _index = 'wiki_de_prefix_2021_06_07';
// export const _index = 'wiki_en_prefix_2021_05_17';
export const _index_wiki = 'wiki_en';
export const _index_api = 'cgi_interface';
export const _index_fw_changelog = 'fw_changelog';
export const _index_iv_changelog = 'iv_changelog';
// export const _type = '_doc';